import React from "react";
import Contact from "./components/contact/Contact";
import Features from "./components/features/Features";
import Hero from "./components/hero/Hero";
import Navbar from "./components/navbar/Navbar";
import Promo from "./components/promo/Promo";

const Main = () => {
  return (
    <div className="main" style={{ backgroundColor: "#ffff66" }}>
      <Navbar />
      <Hero />
      <Features />
      <Promo />
      <Contact />
    </div>
  );
};

export default Main;
